import React from 'react';
import { Link } from 'react-router-dom';
import { CMS_MODULES } from '../../../data/cmsAdminConfig';
import '../../../styles/admin-cms.scss';

export default function AdminContentDashboard() {
	return (
		<div className="admin-cms-dashboard">
			<header className="admin-cms-dashboard__head">
				<h1>Content Management</h1>
				<p>
					Manage journeys, destinations, festivals, guides, media, and official sources.
					Published content is served from the database — no code deploy needed.
				</p>
			</header>
			<div className="admin-cms-dashboard__grid">
				{CMS_MODULES.map((mod) => (
					<Link key={mod.id} to={mod.listPath} className="admin-cms-card">
						<span className="admin-cms-card__icon" aria-hidden="true">
							<i className={mod.icon} />
						</span>
						<h2>{mod.title}</h2>
						<p>{mod.description}</p>
						<span className="admin-cms-card__cta">Manage →</span>
					</Link>
				))}
			</div>
		</div>
	);
}
